module.exports = __webpack_public_path__ + "static/media/PB_G_03.522b2f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_03.png
// module id = 216
// module chunks = 0